export const formatPDFDisplayNumber = (value: number, toFixedNumber?: number): any => {
  if (value === undefined || value === null || isNaN(value)) return value;
  return value >= 1000 ? Math.round(value).toLocaleString() : value?.toFixed(toFixedNumber || 0);
};
